export default __webpack_public_path__ + "static/media/downOutlined.fb4a030f.svg";